export default __webpack_public_path__ + "static/media/save.52391c32.png";